export const DATA = {
  ADVANCED: "Above-average flexibility",
  AVERAGE: "Average flexibility",
  LIMITED: "Limited flexibility",
  UNKNOWN: "Not sure",
};
